import type { TradeAllocationFormResult } from 'models/forms/TradeAllocationFormResult';
import type {
  ITradeAllocationModificationResult,
  ITradeAllocationRequestModel,
} from 'routes/quote/trade-allocations/trade-allocations.types';
import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import type { IHttpClient } from 'utils/http.old/httpClient.model';

export interface TradeAllocationApi {
  fetchFormValues(tabId: string, tradeId: string): Observable<TradeAllocationFormResult>;
  apply(tradeId: string, data: ITradeAllocationRequestModel): Observable<ITradeAllocationModificationResult>;
}

export function tradeAllocationApi(http$: IHttpClient, timeoutInMillis: number): TradeAllocationApi {
  return {
    fetchFormValues(tabId: string, tradeId: string): Observable<TradeAllocationFormResult> {
      return http$
        .getJSON<TradeAllocationFormResult>({
          url: `api/v1/trade-allocation-form/${tabId}/default/${tradeId}`,
          timeOut: timeoutInMillis,
        })
        .pipe(map(({ payload }) => payload));
    },
    apply(tradeId, data): Observable<ITradeAllocationModificationResult> {
      return http$
        .post<ITradeAllocationModificationResult>({
          url: `api/v1/trade-allocation-form/${tradeId}`,
          body: data,
          timeOut: timeoutInMillis,
        })
        .pipe(map(({ payload }) => payload));
    },
  };
}
